import { Component, OnInit, Input, Optional, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormControl } from '@angular/forms';
import { DataAccess } from '../../../data-access/services/data-access.service';
import { requiredModuleError } from '../../../shared/exceptions';
import { Expanding } from '../../../shared/animations/expanding';
import { combineLatest, BehaviorSubject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';



@Component({
  selector: 'bm-grid-container',
  templateUrl: './grid-container.component.html',
  styleUrls: ['./grid-container.component.scss'],
  animations: [Expanding],
})

export class GridContainerComponent implements OnInit, OnDestroy {

  @Input() dataFetchAction: string;
  loading = false;
  grids: any[] = [];
  pageIndex = new BehaviorSubject<number>(1);
  pageSize = new FormControl();
  subscription: Subscription;

  constructor(
    private dataAccess: DataAccess,
    @Optional() private activatedRoute: ActivatedRoute) {

    if (!this.activatedRoute) {
      requiredModuleError('Router');
    }

  }


  searchByParams;

  onSearch() {
    this.pageIndex.next(1);
  }


  incPageIndex() {
    const index = this.pageIndex.value;
    this.pageIndex.next(index + 1);
  }

  decPageIndex() {
    const index = this.pageIndex.value;
    if (index > 1) {
      this.pageIndex.next(index - 1);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {


    this.subscription = combineLatest(
      this.activatedRoute.paramMap,
      this.activatedRoute.queryParamMap,
      this.pageIndex,
      this.pageSize.valueChanges)
    .pipe(debounceTime(10))
    .subscribe(([params, queries, index, size]) => {


      const action = params.get('action');
      const extraParams = {} as any;

      queries.keys.forEach(key => {
        extraParams[key] = queries.get(key);
      });

      extraParams.page = index;
      extraParams.records = size;

      this.loading = true;
      this.dataAccess.execute(action, extraParams)
      .then(response => {
        this.loading = false;
        const {data, additionalInfo, searchBy} = response;


        this.searchByParams = searchBy;

        this.grids = data.map((item, _index) => {
          return {
            data: item,
            bindings: additionalInfo && additionalInfo['res' + _index] || [],
          };
        });

      });
    });

    this.pageSize.setValue(20);
    this.pageIndex.next(1);

  }

}
